/**
 * Hook que carga GET /api/license/usage-summary y lo expone.
 * Lo usan TeamPage, MassCampaignsPage, DevelopmentsPage para mostrar badges
 * "X/Y usuarios", "Te quedan N envíos este mes", etc.
 *
 * Refresca al montar y cuando se dispara `dealider:usage-refresh`.
 */
import { useCallback, useEffect, useState } from 'react';
import api from '@/lib/api';

export default function useUsageSummary() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const r = await api.get('/license/usage-summary');
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(e?.response?.data?.detail || 'No se pudo cargar el resumen de uso');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
    const handler = () => reload();
    window.addEventListener('dealider:usage-refresh', handler);
    return () => window.removeEventListener('dealider:usage-refresh', handler);
  }, [reload]);

  return { data, loading, error, reload };
}
